var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row",class:_vm.notificationClass},[_c('div',{staticClass:"py-4 text-center flex-1",attrs:{"data-test":"notification","data-test-notification":_vm.notification.dataTest}},[_vm._v("\n    "+_vm._s(_vm.notification.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }